import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { Ban } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function usePublicForm(form) {
  const { link } = useParams();
  const [info, setInfo] = useState(null);
  useEffect(() => {
    axios.get(`${API}/public/form-info`, { params: { link: link || "" } }).then((r) => setInfo(r.data)).catch((e) => setInfo({ enabled: {}, name: "", mention: e?.response?.data?.detail?.mention }));
  }, [link]);
  const headers = link ? { "x-public-link": link } : {};
  return { link, headers, info, available: info ? !!info.enabled?.[form] : null, logoQs: link ? `?plink=${encodeURIComponent(link)}` : "" };
}

export const Unavailable = ({ info }) => (
  <div className="min-h-screen grid place-items-center bg-slate-100 p-6" data-testid="public-form-unavailable">
    <div className="max-w-md w-full bg-white rounded-md border border-slate-200 p-8 text-center">
      <Ban className="h-12 w-12 mx-auto text-slate-400 mb-3" />
      {info?.name && <div className="font-display font-bold text-lg text-slate-900">{info.name}</div>}
      <h1 className="font-display text-2xl font-extrabold text-slate-900 mt-1">Page indisponible</h1>
      <p className="text-sm text-slate-600 mt-2">Cette page n'est pas accessible pour le moment.</p>
      <OwnershipNote info={info} />
    </div>
  </div>
);

export const OwnershipNote = ({ info }) => info?.mention ? (
  <p className="mt-6 text-center text-[11px] tracking-wide text-slate-500" data-testid="public-form-mention">{info.mention}</p>
) : null;
